import type { ReactNode } from "react";

export interface ButtonStackProps {
  direction?: "vertical" | "horizontal";
  children?: ReactNode;
}

export function ButtonStack({ direction, children }: ButtonStackProps) {
  return (
    <div className="ButtonStack" data-direction={direction}>
      {children}
    </div>
  );
}
